import React, { useState } from 'react'
import ExportModal from '../../../Components/ExportModal'
import Label from '../../../Components/Label'
import Select from '../../../Components/Select'

export default function ExportOrdersModal({ onClose }) {
  const [category, setCategory] = useState('all')
  const [visibility, setVisibility] = useState('all')

  return (
    <ExportModal
      title="Export Orders"
      exportUrl="/manage/orders/export"
      onClose={onClose}
      extraParams={{ category, visibility }}
    >
      {/* Category Filter */}
      <div>
        <Label className="mb-2">Category</Label>
        <Select value={category} onChange={(e) => setCategory(e.target.value)}>
          <option value="all">All Categories</option>
          <option value="food">Food Only</option>
          <option value="drinks">Drinks Only</option>
        </Select>
      </div>

      {/* Visibility Filter */}
      <div>
        <Label className="mb-2">Item Visibility</Label>
        <Select value={visibility} onChange={(e) => setVisibility(e.target.value)}>
          <option value="all">All Items</option>
          <option value="visible">Currently Visible Only</option>
        </Select>
      </div>
    </ExportModal>
  )
}
